(function ($) {
  Drupal.behaviors.styleguideV1 = {
    attach: function (context) {
      var $template = $('.js-styleguide-v1', context);
      var $toggleCode = $('.js-styleguide-trigger-code', $template);
      var $toggleNav = $('.js-styleguide-trigger-nav', $template);
      var $toggleCodePane = $('.styleguide__component-code', $template);
      var $navList = $('.js-styleguide__nav-list', $template);
      var navText = $template.find('[data-navlabel]');

      if ($toggleCodePane.length) {
        $template.addClass('code-hidden');
      }
      if ($navList.length) {
        $template.addClass('nav-hidden');
      }
      // Generate nav items if we have populated templates.
      if (navText.length) {
        var mappedItems = navText.map(function () {
          var $this = $(this);
          var item = document.createElement('li');

          item.innerHTML = '<a href="#' + $this.attr('id') + '">' + $this.data('navlabel') + '</a>';

          return item;
        });

        $navList.append(mappedItems);
      }

      $toggleCode.once().on('click', function () {
        $template.toggleClass('code-hidden');
      });

      $toggleNav.once().on('click', function () {
        $template.toggleClass('nav-hidden');
      });
    }
  };
})(jQuery);
